<template>
  <div class="programmer">
    <div class="banner">
      <div>
        <h1>程序员，该如何开启人生第二曲线？</h1>
        <h2>不破不立</h2>
        <p>移民加拿大 <span> • </span> 完成创业梦想</p>
      </div>
    </div>

    <div class="provide">
      <img :src="`${QNHost}/Programmer/02.png`" alt="" />
      <div>
        <h5>因为你有<img :src="`${QNHost}/Programmer/07.png`" alt="" /></h5>
        <ul>
          <li>
            <div>
              <p>互联网、物联网、人工智能</p>
              <p>区块链等项目的开发能力</p>
            </div>
          </li>
          <li><div>可落地的项目思路</div></li>
          <li><div>英语雅思5分</div></li>
        </ul>
        <p class="conclusion">你的人生拥有了另一种可能</p>
      </div>
    </div>

    <div class="provide">
      <img :src="`${QNHost}/Programmer/03.png`" alt="" />
      <p class="line"></p>
      <div>
        <h5>我们可提供<img :src="`${QNHost}/Programmer/07.png`" alt="" /></h5>
        <ul>
          <li><div>创业种子资金</div></li>
          <li><div>创业者全家加拿大枫叶卡申请</div></li>
        </ul>
      </div>
    </div>

    <div class="features-title">
      <h2>带着事业移民加拿大</h2>
      <h3>开启人生第二曲线</h3>
      <div class="split-line">
        <img :src="`${QNHost}/Programmer/09.png`" alt="" />
        <img :src="`${QNHost}/Programmer/09.png`" alt="" />
        <img :src="`${QNHost}/Programmer/09.png`" alt="" />
      </div>
      <p>你将获得</p>
      <p class="arrow">
        <img :src="`${QNHost}/Programmer/06.png`" alt="">
      </p>
    </div>

    <div class="features">
      <div>
        <h5>一份自己的事业 ▶</h5>
        <p>移民后，有事做，有收入</p>
        <p>可更快融入当地生活</p>
        <p>还有望成为下一个“独角兽”企业</p>
      </div>
      <div>
        <h5>优质免费教育 ▶</h5>
        <p>加拿大教育资源丰富均衡，子女竞争压力相对小</p>
        <p>十二年免费教育体制</p>
        <p>政府倡导“家门口就是最好的学校”</p>
      </div>
      <div>
        <h5>全民免费的医疗体制 ▶</h5>
        <p>政府每年拨款48亿加元提供免费医疗</p>
        <p>终生享免费医疗，不用担心生不起病</p>
      </div>
      <div>
        <h5>无忧父母赡养问题 ▶</h5>
        <p>加拿大支持亲属移民</p>
        <p>传统移民国家华裔占比高</p>
      </div>
    </div>

    <div class="mid-title">
      <p>&lt;&lt; 加拿大全球创新技术人才招纳中 &gt;&gt;</p>
    </div>

    <div class="register">
      <form action="">
        <input type="text" v-model="formData.name" placeholder="您的姓名:" />
        <input type="text" v-model="formData.phone" placeholder="您的电话:" />
        <button type="button" @click="submitForm">提交获取专属定制方案</button>
        <button class="coupon" type="button">报名即获2000元服务费抵扣券</button>
      </form>
    </div>

    <div class="features-title">
      <h2>为什么选择</h2>
      <h3>加拿大联邦创业移民？</h3>
      <div class="split-line">
        <img :src="`${QNHost}/Programmer/09.png`" alt="" />
        <img :src="`${QNHost}/Programmer/09.png`" alt="" />
        <img :src="`${QNHost}/Programmer/09.png`" alt="" />
      </div>
    </div>

    <div class="features features-second">
      <div>
        <h5>申请周期短 ▶</h5>
        <p>最快6个月登陆加拿大</p>
        <p>最快12个月获批永居身份</p>
      </div>
      <div>
        <h5>申请简单 ▶</h5>
        <p>申请文件简单</p>
        <p>无需解释资金来源</p>
      </div>
      <div>
        <h5>成功率高 ▶</h5>
        <p>移民局对公司运营程度无要求</p>
        <p>生意成败不影响枫叶卡获批</p>
      </div>
      <div>
        <h5>性价比高 ▶</h5>
        <p>福利大国，享终身免费医疗和丰富教育资源</p>
        <p>一步到位永居身份，获批与否确定性强</p>
      </div>
      <div>
        <h5>无居住限制 ▶</h5>
        <p>与省移民项目不同</p>
        <p>可选任意想去的城市生活</p>
      </div>
      <div>
        <h5>轻松赴美 ▶</h5>
        <p>可持TN签证轻松赴美工作</p>
      </div>
    </div>

    <div class="slogan">
      <div class="">
        <div>
          <p>加拿大联邦创业移民</p>
          <p>给未来一种全新可能</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecordMixin from '@/components/recordUser/recordMixin';

export default {
  mixins: [RecordMixin]
};
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
